export const snakeCaseToCamelCase = (value: string) => {
  return value.replace(/_\w/g, (m) => m[1].toUpperCase());
};
